import React from 'react';
import Subcomponent from './subComponent';
import PreLoaderComponent from './preloader.js';
import { ALTERATION_API } from '../constants';


// const ALTERATION_API = `http://qa.rm.qualitapps.com/api/alteration`;
// const ALTERATION_API = `http://rmapi.geseme.com/api/alteration`;
// const ALTERATION_API = `http://192.168.88.15:8080/api/alteration`;
// const ALTERATION_API = `http://dev.api.rmagile.qualitapps.com/api/alteration`;

class EditComponent extends React.Component {
    constructor(props) {
        super(props);
        this.componentIdChange = this.componentIdChange.bind(this);
        this.reload_app = this.reload_app.bind(this);
        this.editSubComponent = this.editSubComponent.bind(this);
      }

    state = {
        topAlerationId : '',
        changedAlteration : {},
        loadAddPopup: false,
        preLoader: false,
        selectedAlteration: {}
    }

    componentDidMount() {
        let selectedAlteration = this.props.selectedAlteration.filter(x => x.component.id === this.props.selectedAlterationId);

        this.setState({topAlerationId: this.props.selectedAlterationId, selectedAlteration: selectedAlteration});

     }

     loadEditPopup = async () => {

        this.setState({
            loadAddPopup: true
        })
    }

    closeEditPopup = async () => {

        this.setState({
            loadAddPopup: false
        })
    }

     componentIdChange(e) {

        this.setState({topAlerationId: e.target.value});
        let changedAlterationObj = this.props.selectedAlteration;
        changedAlterationObj.component.id = e.target.value
        this.setState({changedAlteration: changedAlterationObj});
     }

     componentWillReceiveProps(nextProps, prevProps){

        if(this.props.preLoader == prevProps.preLoader) {
            this.setState({preLoader: false});
        }
     }


     subComponentIdChange(e) {
     }

     updateAleration = async (e) => {
         const putAPI = ALTERATION_API+'/'+this.state.changedAlteration._id;
         const token = localStorage.getItem('token');

         const response = await fetch(putAPI, {
                method: 'PUT',
                headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                component: this.state.changedAlteration.component,
                sub_components: this.state.changedAlteration.sub_components,
                _id: this.state.changedAlteration._id,
                __v: this.state.changedAlteration._id.__v
                })
            });
     }

    reload_app(){
        this.props.reload_app();
        this.setState({
            preLoader: true
        })
    }

    editSubComponent(obj){
        this.setState({
            preLoader: true
        })
        this.props.reload_app(obj);
    }

    render () {

        let allAlterations = this.props.selectedAlteration.filter(x => x.component.id === this.props.selectedAlterationId);

        let selectedAlteration = [...allAlterations][0]
        return (
            <div>
                { this.state.preLoader === true &&
                    <PreLoaderComponent />
                    
                }
            <div className={'row jumbotron scroll'}>        
                <div className={'text-left'}>           
                    <h3>{selectedAlteration.component.name} - {this.state.topAlerationId}</h3>
                   {
                       selectedAlteration.sub_components.map((subComponentArray, subComponentIteration) => {
                           return (
                               <div key = {subComponentIteration} className={'col-xs-6 p-0'}>
                               <Subcomponent
                                    key = {subComponentArray.id}
                                    subComponent = {subComponentArray}
                                    selectedAlteration = {selectedAlteration}
                                    alteration = {selectedAlteration.sub_components}
                                    alterationId = {selectedAlteration._id}
                                    alterationName = {selectedAlteration.component.name}
                                    reload_app={this.reload_app.bind()}
                                    editSubComponent = {this.editSubComponent.bind()}
                               />
                               </div>
                           )
                       })
                   }
                </div>
            </div>
            <div className={'row'}>
                            <button className={'btn btn-danger pull-left backButton'} onClick = {this.props.backToParent}>Anterior</button>
                            </div>
            </div>
        )
    }
}

export default EditComponent;



// WEBPACK FOOTER //
// ./src/components/editComponent.js